import styled, {css} from 'styled-components';
import {device} from 'styled/device';
import {NavigationStatus} from './NavigationAlert';

type WrapperProps = {
  status: NavigationStatus;
};

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  border-radius: 10px;
  display: flex;
  padding: 16px;
  justify-content: space-between;
  margin-bottom: 8px;
  ${props =>
    props.status === NavigationStatus.success &&
    css`
      background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 0.9),
          rgba(255, 255, 255, 0.9)
        ),
        #32d7be;
      border: 1.5px solid #32d7be;
      color: #32d7be;
    `}

  ${props =>
    props.status === NavigationStatus.warning &&
    css`
      background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 0.9),
          rgba(255, 255, 255, 0.9)
        ),
        #ffb27d;

      border: 1.5px solid #ffb27d;
      color: #ffb27d;
    `};

  @media (min-width: ${device.tablet}) {
    margin-bottom: 16px;
  }

  @media (min-width: ${device.laptop}) {
    max-width: 580px;
    margin: 0 auto 16px;
  }
`;

export const Message = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  width: 90%;
`;
